import React from 'react';

function PercentualLineIco({ height = "24px", width = "24px", viewBox = "0 -960 960 960", fill = "#020317" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox={viewBox}
      fill={fill}
    >
      <text
        x="50%"
        y="-800"
        textAnchor="middle"
        fontSize="160"
        fill={fill}
        fontFamily="Arial, sans-serif"
      >
        % percent
      </text>
      <path d="m140-220-60-60 300-300 160 160 284-320 56 56-340 384-160-160-240 240Z" />
    </svg>
  );
}

export default PercentualLineIco;
